// extracted by mini-css-extract-plugin
export default {"not-found-stub-wrapper":"not-found-stub-wrapper__fVS6P","not-found-stub":"not-found-stub__RWSYA"};